goog.provide('el8.ptdata.eligibilities');
goog.provide('el8.ptdata.model.coverage');

goog.require('el8.model.base');
goog.require('el8.service.urls');
goog.require('el8.service.intervals');
goog.require('el8.uiwidget.alert');

(function() {

    var _classCoverage = function(spec) {
        this.populate(spec);
    };
    _classCoverage.inheritsFrom(el8_Entity);
    _classCoverage.addStringProperty('status');
    _classCoverage.addStringProperty('serviceType');
    _classCoverage.addStringProperty('planName');
    _classCoverage.addBoolean('active');

    el8.ptdata.model.coverage = function(spec) {
        return new _classCoverage(spec);
    };

})();

el8.ptdata.eligibilities = (function() {

    var _class = function(spec) {
        this.populate(spec);
    };
    _class.inheritsFrom(el8_Entity);
    _class.addDateTime('createDate');
    _class.addStringProperty('pbmName');
    _class.addStringProperty('error');
    _class.addStringProperty('planName');
    _class.addStringProperty('planStatus');
    _class.addStringProperty('planPcn');
    _class.addBoolean('retryAllowed');

    /** 
     * This is a dict:
     * { full_name: fullName,
     *   dob: dob,  // DATE
     *   sex: sex,
     *   full_address: fullAddress }
     */
    _class.addProperty('eligPatient');
    _class.addBoolean('hasUpdates');

    _class.addModelSetProperty('coverages', el8.ptdata.model.coverage, false, []);
    _class.prototype.hasActiveCoverage = function() {
        for (var i=0; i<this.getCoverages().length; i++) {
            if (this.getCoverages()[i].isActive()) {
                return true;
            }
        }
        return false;
    };

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlLoad: function() { return el8.service.urls.get('eligibilities'); }
    });

    that.hasValid = function() {
        var allElig = that.all();
        if (!allElig.length) { return false; }
        for (var i=0; i<allElig.length; i++) {
            if (!allElig[i].getError()) {
                return true;
            }
        }
        return false;
    };
    
    that.isRetryAllowed = function() {
        var allElig = that.all();
        if (!allElig.length) { return true; }
        for (var i=0; i<allElig.length; i++) {
            if (!allElig[i].isRetryAllowed()) {
                return false;
            }
        }
        return true;
    };

    that.getLastError = function() {
        var allElig = that.all();
        var result = '';
        for (var i=0; i<allElig.length; i++) {
            if (allElig[i].getError()) {
                result = allElig[i].getError();
            }
        }
        return result;
    };

    that.hasActiveCoverage = function() {
        var all = that.all();
        for (var i=0; i<all.length; i++) {
            if (all[i].hasActiveCoverage()) {
                return true;
            }
        }
        return false;
    };

    return that;

})();


